import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const Insurance = {
  id: 'insurance',
  name: BulkActions.insurance.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.insurance], ids, GuidService.newGuid(), filters));
  },
};
